import { Component, input, output, computed, inject, signal, DestroyRef } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { CommonModule } from '@angular/common'
import { CdkDropList, CdkDrag, CdkDragDrop } from '@angular/cdk/drag-drop'
import { Kanban } from '../../../../_services/kanban/kanban.model'
import {
  ActionsConfigProps,
  FieldConfig,
  KanbanCardComponent
} from '../../entities/kanban-card/kanban-card.component'
import { KanbanService } from '../../kanban.service'
import { KanbanColumn } from '../../utils/kanban-column'
import { InfiniteScrollDirective, LoadingComponent } from '@visio-ai/ui-kit'
import { TagChangeEvent, TagsConfig } from '../../models/kanban.model'

@Component({
  selector: 'app-kanban-column',
  standalone: true,
  imports: [
    CommonModule,
    CdkDropList,
    CdkDrag,
    KanbanCardComponent,
    InfiniteScrollDirective,
    LoadingComponent
  ],
  templateUrl: './kanban-column.component.html',
  styleUrl: './kanban-column.component.scss'
})
export class KanbanColumnComponent {
  private kanbanService = inject(KanbanService)
  private destroyRef = inject(DestroyRef)
  actionsConfig = input<ActionsConfigProps>()

  phase = input.required<string>()
  connectedDropLists = input<string[]>([])
  columnData = input.required<KanbanColumn>()
  fieldsToShow = input<FieldConfig[]>()
  tagsConfig = input.required<TagsConfig>()

  // Outputs for Phase interactions
  addCard = output<string>()
  editCard = output<Kanban.Card.Entity>()
  deleteCard = output<string>()
  cardClick = output<Kanban.Card.Entity>()
  deletePhase = output<string>()
  cardDrop = output<CdkDragDrop<Kanban.Card.Entity[]>>()
  requestMoreCards = output<string>()
  openPhaseForm = output<Kanban.Card.Entity>()
  tagSelected = output<TagChangeEvent>()
  tagRemoved = output<TagChangeEvent>()

  loading = signal(false)

  cards = computed(() => this.columnData()?.cards || [])
  cardCount = computed(() => this.columnData()?.totalCount || 0)
  phaseName = computed(() => this.kanbanService.getPhaseName(this.phase()))

  onAddCard(): void {
    this.addCard.emit(this.phase())
  }

  onCardClick(card: Kanban.Card.Entity): void {
    this.cardClick.emit(card)
  }

  onEditCard(card: Kanban.Card.Entity): void {
    this.editCard.emit(card)
  }

  onDeleteCard(cardId: string): void {
    this.deleteCard.emit(cardId)
  }

  onDeletePhase(): void {
    this.deletePhase.emit(this.phase())
  }

  onRequestMoreCards() {
    this.loading.set(true)
    this.kanbanService.getCardsByPhase(this.phase()).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: res => {
        this.kanbanService.updatePhase(res)
      },
      complete: () => {
        this.loading.set(false)
      }
    })
  }

  onTagSelected(tagChangeEvent: TagChangeEvent) {
    this.tagSelected.emit(tagChangeEvent)
  }

  onTagRemoved(tagChangeEvent: TagChangeEvent) {
    this.tagRemoved.emit(tagChangeEvent)
  }
}
